import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "& > div": {
      top: 0,
      paddingBottom: theme.hv.spacing.lg,
    },
  },
  form: {
    marginLeft: "0%",
    flexBasis: "calc(66.666667% + 60px)",
    maxWidth: "unset",
  },
  sectionMargin: {
    marginTop: theme.hv.spacing.md,
    outline: "none",
  },
  icon: {
    position: "absolute",
    marginTop: "20px",
    marginLeft: "37px",
    zIndex: 1099,
  },
  loading: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100vh",
  },
  zIndex: {
    // We need to set this nonsense value to make sure the loading overlays all HVS page elements.
    zIndex: 9999999999,
  },
  firstLastColumn: {
    flexBasis: "calc(16.666667% - 30px)",
  },
}));

export default useStyles;
